import { render, staticRenderFns } from "./modal-proof-sent.vue?vue&type=template&id=cc7fa91a&"
import script from "./modal-proof-sent.vue?vue&type=script&lang=js&"
export * from "./modal-proof-sent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports